import Main from "_c/main"

export default {
    path: "/",
    name: "",
    component: Main,
    children: [
        {
            path: "/purchase",
            name: "purchase",
            component: () => import('@/view/purchase'),
            meta:{
                parent:true,
                parentName:"purchase",
                name:"采购",
                assess:true
            },
            children: [
                {
                    path: "orders",
                    name: "orders",
                    component: () => import("@/view/purchase/orders"),
                    meta:{
                        parent:false,
                        parentName:"purchase",
                        name:"采购单管理",
                        assess:true
                    }
                },
        
            ]
        }
    ]

}


// WEBPACK FOOTER //
// ./src/router/modules/purchase.js